import Blocks from "@/components/Blocks"
import Block from "@/components/wrappers/block"
import Breadcrumbs from "@/components/base/breadcrumbs/breadcrumbs"
import { usePropsObject } from "@/lib/contexts/appContext"
import styles from "./calendar-single.module.css"

export default function EventMain({ block, settings }) {
  let object = usePropsObject()

  if (block?.attrs?.preview) {
    object = block.attrs.preview
  }

  const childSettings = {
    "theme/event-content": settings,
    "theme/event-info": settings
  }

  const crumbs = [
    { label: "Startsida", uri: "/" },
    { label: "Engagera dig", uri: "/engagera-dig/" },
    { label: "Kalender", uri: "/engagera-dig/kalender/" },
    { label: object.title, uri: null }
  ]

  return (
    <>
      <Breadcrumbs
        crumbs={crumbs}
        width="full"
        gap="none"
        className={styles.crumbs}
      />
      <Block
        id={block.attrs.id}
        block={block}
        width="full"
        gap="normal"
        className={styles.main}>
        <Blocks blocks={block.innerBlocks} settings={childSettings} />
      </Block>
    </>
  )
}
